import React, { useEffect } from "react";
import {
	Button,
} from "@mui/material";
import './did-overrides.css';

const Training = ({ gotosimulations }) => {
	  useEffect(() => {
		      const script = document.createElement("script");

		      script.type = "module";
		      script.src = "https://agent.d-id.com/v1/index.js";
		      script.setAttribute("data-name", "did-agent");
		      script.setAttribute("data-mode", "fabio");
		      script.setAttribute("data-client-key", "Z29vZ2xlLW9hdXRoMnwxMTE4NTMwNTQwMTc2NDAzODQ1Njg6YWNUUC1EdHdpcW1MZ0JoTVlfRHd4");
		      script.setAttribute("data-agent-id", "agt_Q5QWp3Ia");
		      script.setAttribute("data-monitor", "true");
		      document.body.appendChild(script);

		      return () => {
			            document.body.removeChild(script);
			          };
		    }, []);

	  return (
		      <div style={{ padding: "20px" }}>
			<Button color="inherit" onClick={gotosimulations} sx={{ mr: 1 }}>
				Training (Simulations)
			</Button>
			<br/>
		        <h2>Scenario #1</h2>
		        <div style={{ height: "100%" }} id="avatar-container">Empathetic Response</div>
		      </div>
		    );
};

export default Training;

